<template>
  <div>
    <b-field
      :label="label"
      label-position="inside"
    >
      <div
        class="taginput-holder"
        :class="{ disabled: noTagsLeft }"
      >
        <Tagify
          ref="input"
          pattern="^[A-Za-z0-9][A-Za-z_\-0-9]{0,23}[A-Za-z0-9]$"
          :placeholder="placeholder"
          :settings="tagifySettings"
          :whitelist="filteredTags"
          :value="selectedTagsVal"
          :on-change="onTagsChange"
          :allow-new="allowNew"
          :autofocus="autofocus"
          @submit="submit"
        />
        <a
          v-if="!allowNew && selectedTags.length > 1"
          class="clear-button"
          :class="{'no-tags-left': noTagsLeft}"
          @click="clearAll"
        >
          <b-icon
            icon="times-circle"
            size="is-small"
          />
        </a>
        <div
          v-if="!allowNew"
          class="help counter"
        >
          {{ selectedTags.length }} / {{ leftTagsNames.length }}
        </div>

        <!-- <b-taginput
          ref="tagInput"
          v-model="selectedTagsVal"
          :data="filteredTags"
          autocomplete
          icon="terminal"
          :confirm-keys='[",", ".", "Enter", "Tab", "#", "/", " "]'
          :allow-new="allowNew"
          :maxtags="maxTags"
          :placeholder="placeholder"
          @input="updateFilteredTags"
          @typing="updateFilteredTags"
          @clicked="addTag"
        >
          <template #empty>
            No tags
          </template>
          <template v-slot="tag">
            #{{tag.option}}
          </template>
          <template v-slot="props">
            <span class="autocomplete-option" v-html="addMatchClass(props.option)"></span>
          </template>
        </b-taginput> -->
      </div>
    </b-field>
  </div>
</template>

<script>
  import { matchSorter } from 'match-sorter'
  import Tagify from '@/qlipmark-shared/components/tags/tagify.vue'

  export default {
    name: 'TagInput',
    components: {
      Tagify
    },
    props: ['label', 'placeholder', 'selectedTags', 'allTagsNames', 'allowNew', 'autofocus'],
    data: function() {
      return {
        filteredTags: [],
        typingStr: '',
        tagifySettings: {
          whitelist: [],
          editTags: false,
          // autoComplete: {
          //   enabled: true,
          //   rightKey: true
          // },
          dropdown : {
            enabled       : 1,              // show the dropdown immediately on focus
            maxItems      : 20,
            position      : "input",         // place the dropdown near the typed text
            closeOnSelect : true,          // keep the dropdown open after selecting a suggestion
            highlightFirst: true,
            sortby        : (suggestions, query) => {
              return matchSorter(this.filteredTags, query); // return sorted array
            }
          },
          delimiters: ",|\\.|\\ |#",
          templates : {
            // tag :  function(tagData){
            //   return `<tag title='${tagData.value}' contenteditable='false' spellcheck="false" class='tagify__tag ${tagData.class ? tagData.class : ""}' ${this.getAttributes(tagData)}>
            //         <x title='remove tag' class='tagify__tag__removeBtn'></x>
            //         <div>
            //           <span class='tagify__tag-text'>${tagData.value}</span>
            //         </div>
            //     </tag>`
            // },
            dropdownItem : function(tagData){
              return `<div class='tagify__dropdown__item ${tagData.class ? tagData.class : ""}' tagifySuggestionIdx="${tagData.tagifySuggestionIdx}">
                  <span>#${tagData.value}</span>
                </div>`
            }
          },
          callbacks: {
            // add(e) {
            //   console.log("tag added:", e.detail);
            // },
            // change(e) {
            //   console.log("tag changeed:", e.detail.tagify.value.map(v => v.value));
            //   // const values = e.detail.tagify.value.map(v => v.value)
            //   // this.$emit('input', values);
            // }

          }
        }
      }
    },
    computed: {
      selectedTagsVal: {
        get() {
          let tags = this.selectedTags
          if (Array.isArray(tags)) {
            tags = tags.join(',')
          }
          return tags;
        },
        set(value) {
          this.$emit('input', value);
        }
      },
      leftTagsNames() {
        let tags = this.allTagsNames

        if (this.selectedTags) {
          tags = tags.filter(tag => !this.selectedTags.includes(tag))
        }

        return tags
      },
      noTagsLeft() {
        let val = false

        if (!this.allowNew && this.leftTagsNames.length == 0) {
          val = true
        }

        return val
      },
      maxTags() {
        let val =  undefined

        if (!this.allowNew) {
          val = this.leftTagsNames.length + this.selectedTags.length
        }

        return val
      }
    },
    watch: {
      selectedTagsVal() {
        this.updateFilteredTags()

        if (this.noTagsLeft) {
          this.maxtags = this.leftTagsNames.length
        }
      },
      leftTagsNames() {
        this.updateFilteredTags()
      }
    },
    mounted() {
      this.updateFilteredTags()
    },
    methods: {
      onTagsChange(e) {
        let tags = []
        const value = e.target.value
        if (value != "") {
          try {
            tags = JSON.parse(value).map(v => v["value"])
          } catch (error) {
            tags = value.split(',')
          }
        }
        this.$emit('input', tags)
      },
      addTag(tag) {
        this.$emit('tagClicked', tag)
      },
      clearAll() {
        this.$emit('clearAllTags')
      },
      submit() {
        this.$emit('submit')
      },
      updateFilteredTags(text) {
        this.typingStr = text
        if (typeof text === 'string') {
          this.filteredTags = this.leftTagsNames.filter((option) => {
            return option.toString()
              .toLowerCase()
              .indexOf(text.toLowerCase()) >= 0
          }).sort((a, b) => {
              return a.indexOf(text) - b.indexOf(text)
          })
        } else {
          this.filteredTags = this.leftTagsNames.filter((option) => {
            return option.toString()
                         .toLowerCase()
          })
        }
      },
      addMatchClass(tag) {
        if (typeof tag === undefined) return
        return tag.replace(RegExp(this.typingStr, "ig"), `<span class="match">${this.typingStr}</span>`)
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .taginput-container {
    margin-bottom: 20px;
  }

  .clear-button {
    margin-left: -22px;
    z-index: 1;
    padding-right: 4px;
  }

  ::v-deep .autocomplete-option {
    font-weight: normal;

    .match {
      font-weight: bold;
    }
  }

  .help.counter {
    margin-top: 0px;
  }
</style>
